import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../Layout/MainLayout";
import Login from "../Pages/Authentication/Login";
import Register from "../Pages/Authentication/Register";
import AddConstructionExpenses from "../Pages/Expenses/Construction/AddConstructionExpenses";
import ConstructionExpenses from "../Pages/Expenses/Construction/ConstructionExpenses";
import AddDHQDeposit from "../Pages/Expenses/DHQ/AddDHQDeposit";
import AddDHQExpense from "../Pages/Expenses/DHQ/AddDHQExpense";
import DHQExpenses from "../Pages/Expenses/DHQ/DHQExpenses";

import Expenses from "../Pages/Expenses/Expenses";
import AllData from "../Pages/HomePage/AllData";
import HomePage from "../Pages/HomePage/HomePage";

export const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <MainLayout/>, 
            children: [
                {
                    path: '/', 
                    element: <HomePage/>
                }, 
                {
                    path: '/login',
                    element: <Login/>
                },
                {
                    path: '/register',
                    element: <Register/>
                },
                {
                    path: '/allData',
                    element: <AllData/>
                },
                {
                    path: '/Expenses',
                    element: <Expenses/>
                },
                {
                    path: '/ConstructionExpenses',
                    element: <ConstructionExpenses/>
                },
                {
                    path: '/AddConstructionExpenses',
                    element: <AddConstructionExpenses/>
                },
                {
                    path: '/DHQexpenses',
                    element: <DHQExpenses/>
                },
                {
                    path: '/AddDHQDeposit',
                    element: <AddDHQDeposit/>
                },
                {
                    path: '/AddDHQEpxense',
                    element: <AddDHQExpense/>
                },
            ]
        }
    ]
)